export default __webpack_public_path__ + "static/media/logo.19ee5cf6.png";